import { Button, Modal, useModal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface VatExemptionMentionInfoModalFooterProps {
  id: string
}

export const VatExemptionMentionInfoModalFooter = ({ id }: VatExemptionMentionInfoModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { close: handleCloseModal } = useModal(id)

  return (
    <Modal.Footer>
      <Button variant="filled" onClick={handleCloseModal}>
        {t('external_invoices.editor.summary.vat_exemption_mention_info.modal.close')}
      </Button>
    </Modal.Footer>
  )
}
